import React from 'react';
import { ReactComponent as NamecheapLogo } from '../assets/logo-namecheap-alt.svg';

export default function PoweredByNamecheap() {
  return (
    <div
      className="
        relative z-10 md:absolute top-0 left-0 right-0 md:left-auto
        inline-flex items-center justify-center p-2 md:p-4
        bg-gray-700 text-gray-200 md:bg-transparent md:text-gray-800
        text-xs font-display uppercase"
      style={{ WebkitFontSmoothing: 'antialiased' }}>
      <NamecheapLogo className="h-4 mr-2" />
      Powered by Namecheap
    </div>
  );
}
